import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import ConfidenceAppend from "nlib/common/ConfidenceAppend";
import React, { useState } from "react";
import SelectProjectInput from "nlib/common/SelectProjectInput";
import VendorValidation from "nlib/common/VendorValidation";

const SelectProject = (props) => {
  const {
    value,
    audit,
    disabled,
    vendorId,
    placeholder,
    transactionId,
    showVendorValidation,
    onChange,
    ...restProps
  } = props;

  const { uiTexts } = useSelector(getTextsData);

  const [inputOpened, setInputOpened] = useState(false);

  const [validationOpened, setValidationOpened] = useState(false);

  return (
    <VendorValidation
      skip={!showVendorValidation || disabled}
      opened={validationOpened && !inputOpened}
      vendorId={vendorId}
      listName="projects"
      name="project"
      entityValue={value}
      confidence={audit ? null : value?.confidence}
      setOpened={setValidationOpened}
      updateTransaction={onChange}>
      {({ iconComponent, showWarning, showCriticalWarning }) => {
        return (
          <ConfidenceAppend
            icon={iconComponent}
            confidence={audit ? null : value?.confidence}>
            <SelectProjectInput
              alignRight
              disabled={disabled}
              value={value}
              invalid={!!(value?.name && !value?.id)}
              valid={!!(value?.name && value?.id)}
              warning={showWarning}
              border={(showWarning || showCriticalWarning) && "warning"}
              placeholder={placeholder || (!value?.name && disabled ? uiTexts.noProject : undefined)}
              opened={inputOpened}
              setOpened={setInputOpened}
              onChange={onChange}
              {...restProps} />
          </ConfidenceAppend>
        );
      }}
    </VendorValidation>

  );
};

export default React.memo(SelectProject);
